import {first, forEach, isEmpty, last} from "lodash";
import {tagColors} from "../../../data/shared/tags";
import {popularity} from "../../../data/booking/constants/hike";
// import {getEditingItem} from "data/booking/selectors/booking";

function getStops(hike) {
    let stops = {};
    hike.steps.forEach((step) => {
        if (step.from && step.from.stop && step.from.stop.id) {
            stops[step.from.stop.id] = step.from.stop;
            stops[step.from.stop.id].updateStatus = step.updateStatus
        }
        if (step.to && step.to.stop && step.to.stop.id) {
            stops[step.to.stop.id] = step.to.stop;
            stops[step.to.stop.id].updateStatus = step.updateStatus
        }
    });
    return Object.values(stops);
}

function getSteps(hike) {
    let steps = {};
    hike.steps.forEach((step) => {
        if (step.from && step.from.step) {
            steps[step.from.step.id] = step.from.step;
            steps[step.from.step.id].updateStatus = step.updateStatus
        }
        if (step.to && step.to.step) {
            steps[step.to.step.id] = step.to.step;
            steps[step.to.step.id].updateStatus = step.updateStatus
        }
    });
    return Object.values(steps);
}

function getStepGeojson(departure, arrival, geojson, direction, loop) {
    if (geojson.length && departure.step && arrival.step) {
        let between = false;
        let coordinates = [...geojson[0].geometry.coordinates]
        if(direction == -1){
            coordinates.reverse()
        }
        let newCoordinates = coordinates.filter((coordinates, index) => {
            if ((!loop &&
                departure.step.nearestCoordinates &&
                departure.step.nearestCoordinates.longitude == coordinates[0] &&
                departure.step.nearestCoordinates.latitude == coordinates[1]) ||
                (loop && index == 0)
            ) {
                between = true;
            }
            if (
                arrival.step.nearestCoordinates &&
                arrival.step &&
                arrival.step.nearestCoordinates.longitude == coordinates[0] &&
                arrival.step.nearestCoordinates.latitude == coordinates[1]
            ) {
                between = false;
                return true;
            }
            return between;
        });

        if(loop) {
            let between = false;
            let newLoopCoordinates = coordinates.filter((coordinates, index) => {
                if (
                        departure.step.nearestCoordinates &&
                        departure.step.nearestCoordinates.longitude == coordinates[0] &&
                        departure.step.nearestCoordinates.latitude == coordinates[1]
                ) {
                    between = true;
                }
                return between;
            });

            newCoordinates = newLoopCoordinates.concat(newCoordinates)
        }

        return [
            {
                ...geojson[0],
                geometry: {
                    ...geojson[0].geometry,
                    coordinates: newCoordinates,
                },
            },
        ];
    }
    return null;
}

function getDistance(hike) {
    let distance = 0;
    hike.steps.forEach((step) => {
        distance += step.to.step.distance;
    });
    return distance;
}

function getDeparture(steps) {
    return !isEmpty(steps) ? first(steps).from : null;
}

function getArrival(steps) {
    return !isEmpty(steps) ? last(steps).to : null;
}

function getLastHike(state) {
    const services = state.map.entities.services;
    if (!isEmpty(services)) {
        let serviceWithHike = null;
        Object.keys(services).some(serviceId => {
            if(services[serviceId].hike){
                serviceWithHike = services[serviceId]
                return true;
            }
            return false;
        })
        if(!serviceWithHike){
            return null
        }
        return serviceWithHike.hike.id
            ? serviceWithHike.hike
            : state.map.entities.hikes[serviceWithHike.hike];
    }
    return null;
}

function getHikeList(state) {
    const { hikes } = state.booking.map.entities;
    let tags = {};

    return Object.keys(hikes).map((hikeId) => {
        const hike = hikes[hikeId];
        hike.tags.map(tag => {
            if(isEmpty(tags[tag.value])){
                tags[tag.value] = tagColors[Object.keys(tags).length%tagColors.length]
            }
            tag.color = tags[tag.value]
            return tag
        })

        hike.popularity = popularity[hikeId] ? popularity[hikeId] : 0;

        return hike;
    });
}

function getThemeList(state){
    const { themes } = state.booking.map.entities;

    if(isEmpty(themes)){
        return []
    }

    return Object.keys(themes).map((themeId) => {
        return themes[themeId];
    })
}

function getDirections(state){
    const stepsId = state.booking.map.hike ? state.booking.map.entities.hikes[state.booking.map.hike.id].steps : null
    if(isEmpty(stepsId)){
        return []
    }

    const { steps } = state.booking.map.entities;
    const stepArray = stepsId.map(stepId => steps[stepId])
    const pathDetails = state.booking.map.hike.pathDetails

    let firstStep = first(stepArray)
    let lastStep = last(stepArray)
    if(!isEmpty(pathDetails.boundaries)) {
        firstStep = !isEmpty(steps[pathDetails.boundaries.startAt]) ? steps[pathDetails.boundaries.startAt] : firstStep
        lastStep = !isEmpty(steps[pathDetails.boundaries.endAt]) ? steps[pathDetails.boundaries.endAt] : lastStep
    }

    return [
        {
            name: firstStep.title,
            value: -1
        },
        {
            name: lastStep.title,
            value: 1
        },
    ]
}

function getCurrentDirectionFromState(state){
    let departure = state.booking.map.trip.startStep
    let arrival = state.booking.map.trip.endStep

    if(departure.step && arrival.step) {
        const {steps} = state.booking.map.entities;
        const stepArray = steps ? Object.keys(steps) : []
        let fromIndex = stepArray.indexOf(departure.step.id)
        let toIndex = stepArray.indexOf(arrival.step.id)
        return toIndex > fromIndex ? 1 : -1
    }
    return 1
}

function getCurrentDirection(departure, arrival, steps){

    if(departure && arrival && departure.step && arrival.step && !isEmpty(steps)) {
        const stepArray = Object.keys(steps)
        let fromIndex = stepArray.indexOf(departure.step.id)
        let toIndex = stepArray.indexOf(arrival.step.id)
        return toIndex > fromIndex ? 1 : -1
    }
    return 1
}

export {
    getStops,
    getSteps,
    getDistance,
    getStepGeojson,
    getDeparture,
    getArrival,
    getLastHike,
    getHikeList,
    getThemeList,
    getDirections,
    getCurrentDirection,
    getCurrentDirectionFromState
};
